{
	"admin": {
		"document_title": "{{productName}} · Amministrazione",
		"document_title_unbranded": "Amministrazione",
		"nav_label": "Amministrazione"
	},
	"details": {
		"access": {
			"label": "Chi ha accesso",
			"more_one": "e un’altra persona",
			"more_other": "e altre {{count}} persone"
		},
		"actions": {
			"manage_access": "Gestisci accessi"
		},
		"announce": {
			"closed": "Pannello dei dettagli chiuso",
			"opened": "Pannello dei dettagli aperto"
		},
		"dates": {
			"created": "Caricato il",
			"created_folder": "Creata il",
			"modified": "Aggiornato il",
			"original": "Data originale",
			"original_hint": "La data che il file aveva sul dispositivo di chi lo ha caricato."
		},
		"empty": {
			"description": "Scegli un file o una cartella nella lista per vederne qui i dettagli.",
			"title": "Nessun elemento selezionato"
		},
		"error": {
			"description": "Potrebbe essere stato spostato, eliminato o non essere più condiviso con te.",
			"title": "Non è stato possibile leggere questo elemento"
		},
		"info": {
			"contents": "Contenuto",
			"label": "Informazioni",
			"owner": "Proprietario",
			"size": "Dimensione",
			"type": "Tipo"
		},
		"kind": {
			"file": "File",
			"folder": "Cartella"
		},
		"menu": "Informazioni sul file",
		"open": "Info",
		"path": {
			"label": "Percorso"
		},
		"received": {
			"label": "Origine",
			"value": "Ricevuto tramite link di caricamento da {{name}}"
		},
		"title": "Dettagli",
		"toggle": "Dettagli",
		"trashed": {
			"deleted": "Non sono disponibili altri dettagli.",
			"deleted_at": "Eliminato il {{date}}.",
			"deleted_by": "Eliminato da {{name}} il {{date}}.",
			"restorable_by": "Può ripristinarlo {{name}} dal suo cestino.",
			"restorable_by_unknown": "Può ripristinarlo chi ha accesso, dal proprio cestino.",
			"restore": {
				"action": "Ripristina",
				"error": "Non è stato possibile ripristinare questo elemento. Riprova.",
				"restoring": "Ripristino…"
			},
			"title": "Questo elemento è stato spostato nel cestino"
		},
		"type": {
			"archive": "Archivio",
			"audio": "Audio",
			"document": "Documento",
			"image": "Immagine",
			"presentation": "Presentazione",
			"spreadsheet": "Foglio di calcolo",
			"video": "Video"
		},
		"versions": {
			"current": "Corrente",
			"delete": {
				"action": "Elimina versione",
				"confirm": "Elimina",
				"deleting": "Eliminazione…",
				"description": "Il contenuto di questa versione verrà eliminato per sempre: non potrà più essere aperto, scaricato né ripristinato. La versione resterà nella cronologia come eliminata.",
				"error": "Non è stato possibile eliminare questa versione. Riprova.",
				"success": "Versione {{versionNumber}} eliminata.",
				"title": "Eliminare la versione {{versionNumber}}?"
			},
			"deleted": "Versione eliminata",
			"deleted_label": "Versione {{versionNumber}}, eliminata",
			"empty": {
				"description": "Le versioni precedenti si conservano da questo momento in poi."
			},
			"error": "Non è stato possibile leggere le versioni di questo file.",
			"label": "Versioni",
			"number": "Versione {{versionNumber}}",
			"open": "Apri l’anteprima della versione {{versionNumber}}",
			"preview_title": "{{name}} (versione {{versionNumber}})",
			"restore": {
				"action": "Ripristina questa versione",
				"confirm": "Ripristina",
				"conflict": {
					"changed_by": "Modificato da {{name}} il {{date}}.",
					"reload": "Ricarica la cronologia",
					"title": "Qualcosa è cambiato nel frattempo"
				},
				"description": "Verrà creata una nuova versione con questo contenuto. Le versioni esistenti restano nella cronologia.",
				"error": "Non è stato possibile ripristinare questa versione. Riprova.",
				"restoring": "Ripristino…",
				"success": "Creata la versione {{toVersionNumber}} dal contenuto della versione {{fromVersionNumber}}.",
				"title": "Ripristinare la versione {{versionNumber}}?"
			},
			"row_menu": "Altre azioni sulla versione {{versionNumber}}",
			"show_more": "Mostra altre",
			"today": "Oggi",
			"via_request": "{{name}} · tramite link di caricamento",
			"when": "{{day}}, {{time}}",
			"yesterday": "Ieri"
		}
	},
	"directory_feed": {
		"interrupted": "Gli aggiornamenti automatici sono interrotti. Riconnessione in corso.",
		"unavailable": "Gli aggiornamenti automatici non sono disponibili. Ricarica la pagina per riattivarli.",
		"unavailable_neutral": "Gli aggiornamenti automatici non sono disponibili."
	},
	"favorites": {
		"empty": {
			"description": "Aggiungi file e cartelle dal menu «Aggiungi agli speciali» e li ritroverai qui.",
			"title": "Nessun elemento tra gli speciali"
		},
		"error": {
			"description": "Riprova: non è cambiato niente.",
			"title": "Non siamo riusciti a caricare gli speciali"
		},
		"offline": {
			"description": "Sembri offline, quindi non possiamo caricare i tuoi speciali. Riproveremo appena torna la connessione."
		},
		"title": "Speciali"
	},
	"files": {
		"breadcrumb": {
			"show_hidden": "Mostra le cartelle intermedie"
		},
		"copy": {
			"clipboard": {
				"copied_one": "Elemento copiato negli appunti",
				"copied_other": "{{count}} elementi copiati negli appunti",
				"folders_refused": "Impossibile copiare le cartelle",
				"links_failed": "Impossibile copiare i link negli appunti"
			},
			"copying": "Copia in corso…",
			"created": "Copia creata: {{name}}",
			"created_in_personal_one": "Copia creata in «I miei file»",
			"created_in_personal_other": "{{count}} copie create in «I miei file»",
			"created_many_one": "{{count}} copia creata",
			"created_many_other": "{{count}} copie create",
			"go_to_personal": "Apri",
			"open": "Crea una copia",
			"refusal": {
				"conflict": "Impossibile copiare: il file è in caricamento o è appena cambiato. Riprova tra poco",
				"depth": "Impossibile copiare: la cartella è troppo in profondità",
				"folder": "Impossibile copiare le cartelle",
				"in_progress": "Copia già in corso. Attendi il termine per riprovare",
				"invalid_name": "Impossibile copiare: nome del file non valido in questa cartella",
				"not_found": "Impossibile copiare: file o cartella non più disponibili",
				"path_too_long": "Impossibile copiare: percorso troppo lungo. Scegli una cartella meno profonda",
				"quota": "Impossibile copiare: spazio di archiviazione insufficiente",
				"read_only": "Impossibile copiare: permessi insufficienti per questa cartella",
				"too_large": "Limite di 5 GB superato. Seleziona meno file e riprova",
				"unknown": "Impossibile completare la copia. Riprova"
			},
			"refused_one": "Impossibile copiare {{count}} file",
			"refused_other": "Impossibile copiare {{count}} file"
		},
		"delete": {
			"confirm": "Sposta nel cestino",
			"confirm_description_one": "«{{name}}» verrà spostato nel cestino.",
			"confirm_description_other": "{{count}} elementi verranno spostati nel cestino.",
			"confirm_title": "Spostare nel cestino?",
			"deleting": "Eliminazione…",
			"done_one": "Elemento spostato nel cestino.",
			"done_other": "{{count}} elementi spostati nel cestino.",
			"menu": "Sposta nel cestino",
			"refusal": {
				"insufficient_role": "Non puoi eliminare questo elemento.",
				"unknown": "Non è stato possibile eliminarlo. Riprova.",
				"upload_in_progress": "È ancora in caricamento. Riprova quando è finito."
			},
			"refusal_line": "«{{name}}»: {{reason}}",
			"refused_one": "Un elemento non è stato eliminato.",
			"refused_other": "{{count}} elementi non sono stati eliminati.",
			"undo": "Annulla",
			"undo_error": "Non è stato possibile annullare. Apri il cestino per ripristinarlo a mano.",
			"undoing": "Ripristino…"
		},
		"download": {
			"actions": {
				"cancel": "Annulla il download",
				"retry": "Riprova"
			},
			"detail": {
				"done": "Completato · {{size}}",
				"handed_over": "Lo scarica il browser · {{size}}",
				"missing_one": "Completato · {{count}} file non scaricato",
				"missing_other": "Completato · {{count}} file non scaricati",
				"size_progress": "{{received}} di {{total}}",
				"size_progress_percent": "{{percent}}% · {{received}} di {{total}}",
				"zip_done_one": "Completato · {{count}} file · {{size}}",
				"zip_done_other": "Completato · {{count}} file · {{size}}"
			},
			"failure": {
				"memory": "Il download è troppo grande per il browser. Usa l’app desktop.",
				"none": "I file non esistono più."
			},
			"group": "Download",
			"missing": {
				"hide": "Nascondi",
				"show": "Vedi quali"
			},
			"nothing": "Niente da scaricare",
			"open": "Scarica",
			"refusal": {
				"not_found": "Il file che stai cercando di scaricare non è più disponibile.",
				"unknown": "Download fallito",
				"unknown_retry": "Download fallito, riprova"
			},
			"state": {
				"cancelled": "Annullato",
				"failed": "Non riuscito",
				"paused": "In pausa",
				"queued": "In attesa"
			},
			"too_large": {
				"close": "Chiudi",
				"description": "La selezione supera il limite del browser (max {{limit}}). Usa l’app desktop per scaricare tutti i {{size}}.",
				"description_many": "Questa selezione ha troppi file per il browser. Usa l’app desktop per scaricarla tutta.",
				"description_selection": "Hai selezionato {{count}} elementi, ma il limite del browser è {{max}}. Usa l’app desktop per un download completo.",
				"get_client": "Scarica l’app desktop",
				"ok": "Ho capito",
				"title": "Troppo grande per il browser"
			}
		},
		"drag": {
			"items_one": "{{count}} elemento",
			"items_other": "{{count}} elementi"
		},
		"empty": {
			"description_writable": "Trascina qui i file per caricarli, oppure usa il pulsante Nuovo.",
			"title": "Questa cartella è vuota"
		},
		"error": {
			"description": "Riprova, o ricarica la pagina.",
			"title": "Non è stato possibile caricare questa cartella"
		},
		"favorites": {
			"add": {
				"done_one": "Aggiunto agli Speciali.",
				"done_other": "{{count}} elementi aggiunti agli Speciali.",
				"error": "Impossibile aggiungere agli Speciali. Riprova.",
				"loading_one": "Aggiunta agli Speciali…",
				"loading_other": "Aggiunta di {{count}} elementi agli Speciali…",
				"menu": "Aggiungi agli speciali",
				"partial": "{{done}} elementi su {{total}} aggiunti agli Speciali. Gli altri non sono più raggiungibili.",
				"skipped": "Questi elementi non sono più raggiungibili, quindi non sono stati aggiunti."
			},
			"remove": {
				"done_one": "Rimosso dagli Speciali.",
				"done_other": "{{count}} elementi rimossi dagli Speciali.",
				"error": "Impossibile rimuovere dagli Speciali. Riprova.",
				"loading_one": "Rimozione dagli Speciali…",
				"loading_other": "Rimozione di {{count}} elementi dagli Speciali…",
				"menu": "Rimuovi dagli speciali",
				"partial": "{{done}} elementi su {{total}} rimossi dagli Speciali. Gli altri non sono più raggiungibili.",
				"skipped": "Questi elementi non sono più raggiungibili, quindi non sono stati modificati."
			},
			"tooltip": "Speciali"
		},
		"filters": {
			"category": {
				"archive": "Archivi",
				"audio": "Audio",
				"document": "Documenti",
				"folder": "Cartelle",
				"image": "Immagini",
				"label": "Tipo",
				"other": "Altro",
				"presentation": "Presentazioni",
				"spreadsheet": "Fogli di calcolo",
				"video": "Video"
			},
			"clear_all": "Cancella filtri",
			"empty": {
				"description": "I filtri guardano solo gli elementi di questa cartella, non quelli nelle sottocartelle: quello che cerchi potrebbe essere un livello più sotto.",
				"description_favorites": "I filtri guardano solo gli elementi degli speciali elencati qui, non quello che contengono.",
				"description_search": "I filtri restringono i risultati trovati per questo termine: prova a toglierne uno, o a cercare qualcosa di diverso.",
				"description_shared": "I filtri guardano solo gli elementi condivisi con te elencati qui, non quello che contengono.",
				"description_trash": "I filtri guardano solo gli elementi del cestino elencati qui, non quello che contiene una cartella eliminata.",
				"title": "Nessun elemento corrisponde ai filtri"
			},
			"people": {
				"empty": "Nessuna persona con questo nome.",
				"label": "Persone",
				"search": "Cerca una persona",
				"unnamed": "Nome non disponibile"
			},
			"unreadable": "Una parte dell’indirizzo non era leggibile ({{names}}): l’elenco è aperto senza."
		},
		"item": {
			"children_one": "{{count}} elemento",
			"children_other": "{{count}} elementi",
			"open_folder": "Apri la cartella {{name}}",
			"open_menu": "Altre azioni su {{name}}",
			"shared": "Condiviso",
			"thumbnail_alt": "Anteprima di {{name}}"
		},
		"listing": {
			"actions": "Azioni",
			"modified": "Modificato",
			"name": "Nome",
			"no_value": "Non disponibile",
			"owner": "Proprietario",
			"owner_you": "Tu",
			"path": "Percorso",
			"path_here": "In questa cartella",
			"shared_by": "Condiviso da",
			"size": "Dimensione",
			"sort_by": "Ordina per {{column}}",
			"today": "oggi",
			"yesterday": "ieri"
		},
		"move": {
			"confirm": "Sposta qui",
			"exposes_one": "Spostandolo qui, un’altra persona potrà vederlo.",
			"exposes_other": "Spostandolo qui, altre {{count}} persone potranno vederlo.",
			"exposes_title": "La destinazione è condivisa",
			"exposes_up_to_one": "Spostandoli qui, al massimo un’altra persona potrà vederli.",
			"exposes_up_to_other": "Spostandoli qui, al massimo altre {{count}} persone potranno vederli.",
			"into": "In «{{name}}»",
			"keep_both_one": "Mantieni entrambi",
			"keep_both_other": "Mantieni entrambi ({{count}} elementi)",
			"moved_one": "Elemento spostato.",
			"moved_other": "{{count}} elementi spostati.",
			"moving": "Spostamento…",
			"names_more": "{{names}} e altri {{count}}",
			"no_subfolders": "Nessuna sottocartella",
			"no_subfolders_hint": "Puoi spostare gli elementi direttamente qui, oppure creare una cartella.",
			"open": "Sposta",
			"opens_to_org_one": "Dopo lo spostamento potrà vederlo chiunque in {{org}} abbia il link.",
			"opens_to_org_other": "Dopo lo spostamento potrà vederli chiunque in {{org}} abbia il link.",
			"opens_to_org_title": "La destinazione è aperta a tutta l’organizzazione",
			"path": "Percorso della cartella aperta",
			"preserves_detail": "Le concessioni restano nel pannello di condivisione e si tolgono da lì. Chi era proprietario per ereditarietà diventa editor, e un pannello di condivisione già aperto su questo elemento andrà in conflitto al salvataggio.",
			"preserves_one": "Una persona raggiunge questo elemento solo attraverso la cartella da cui esce. Lo spostamento le scrive una concessione diretta, così non lo perde.",
			"preserves_other": "{{count}} persone raggiungono questo elemento solo attraverso la cartella da cui esce. Lo spostamento scrive loro una concessione diretta, così non lo perdono.",
			"preserves_title": "Chi ha accesso continua ad averlo",
			"preserves_up_to_one": "Al massimo una persona raggiunge questi elementi solo attraverso la cartella da cui escono. Lo spostamento le scrive una concessione diretta, così non li perde.",
			"preserves_up_to_other": "Al massimo {{count}} persone raggiungono questi elementi solo attraverso la cartella da cui escono. Lo spostamento scrive loro una concessione diretta, così non li perdono.",
			"refusal": {
				"cycle": "Una cartella non si può spostare dentro sé stessa.",
				"name_taken_suggested": "Nella destinazione c'è già qualcosa con questo nome. «{{name}}» è libero.",
				"unknown": "Non è stato possibile spostarlo. Riprova."
			},
			"refused_one": "Non è stato possibile spostarlo.",
			"refused_other": "Non è stato possibile spostare {{count}} elementi.",
			"title_one": "Sposta «{{name}}» in…",
			"title_other": "Sposta {{count}} elementi in…",
			"unavailable_moving": "«{{name}}»: lo stai spostando",
			"unavailable_role": "«{{name}}»: non puoi aggiungere niente in questa cartella",
			"unnamed": "questa cartella"
		},
		"name": {
			"already_there": "«{{name}}» esisteva già in questa cartella: ti abbiamo portato lì, non è stata creata.",
			"cancel": "Annulla",
			"create_confirm": "Crea",
			"created": "Cartella «{{name}}» creata.",
			"created_in": "Verrà creata in «{{name}}»",
			"creating": "Creazione…",
			"label": "Nome",
			"length": "{{length}} di {{max}} caratteri",
			"new": "Nuovo",
			"new_folder": "Nuova cartella",
			"new_folder_default": "Cartella senza titolo",
			"rename": "Rinomina",
			"renamed": "Rinominato in «{{name}}».",
			"renaming": "Ridenominazione…"
		},
		"name_refusal": {
			"insufficient_role": "Non hai i permessi per scrivere in questa cartella.",
			"invalid_name": {
				"empty": "Il nome non può essere vuoto.",
				"illegal_character": "Il nome contiene un carattere che non si può usare: / \\ : * ? \" < > | o altri caratteri non ammessi",
				"relative_path": "«.» e «..» non sono nomi: indicano un percorso.",
				"reserved_name": "Questo nome è riservato da Windows e non si può usare. Scegline un altro.",
				"too_long": "Il nome è troppo lungo. Accorcialo.",
				"trailing_dot_or_space": "Il nome non può finire con un punto o con uno spazio.",
				"unknown": "Il nome non rispetta le regole di denominazione. Provane un altro."
			},
			"looks_identical": "Il nome che hai scritto sembra identico a uno già presente ma è composto in modo diverso: succede quando lo stesso accento viene scritto da un Mac e da un Windows.",
			"max_depth_exceeded": "Hai raggiunto la profondità massima consentita. Crea questa cartella più in alto nell’albero.",
			"name_taken": "In questa cartella esiste già un elemento con questo nome. Maiuscole e minuscole non fanno differenza.",
			"not_found": "Questa cartella non esiste più, o non è più accessibile.",
			"parent_not_folder": "Un file non può contenere altri elementi.",
			"parent_trashed": "La cartella di destinazione è nel cestino. Ripristinala prima.",
			"path_too_long": "Il percorso completo diventerebbe troppo lungo per i client desktop. Usa un nome più corto, o una cartella meno profonda.",
			"personal_folder_cannot_move": "Una cartella personale sta sempre in cima al suo albero e non si può spostare.",
			"personal_folder_fixed_name": "La tua cartella personale prende il nome dalla lingua in cui leggi, quindi non si rinomina.",
			"suggested": "Un nome libero in questa cartella è «{{name}}»."
		},
		"nav_label": "I miei file",
		"offline": {
			"description": "Verrà caricata di nuovo appena torna la connessione.",
			"title": "Nessuna connessione"
		},
		"open": {
			"label": "Apri",
			"new_tab": "Apri in un'altra scheda",
			"reveal": "Apri nella cartella",
			"unavailable": {
				"description": "Potrebbe essere stato spostato, eliminato o non condiviso con te, oppure la connessione si è interrotta. Torna ai tuoi file e riprova.",
				"title": "Questo file non si può aprire"
			}
		},
		"origin": {
			"organization": "Aperto a tutta l’organizzazione da {{name}}",
			"shared_by": "Condiviso da {{name}}"
		},
		"preview": {
			"error": {
				"description": "Controlla la connessione e riprova.",
				"title": "Anteprima non caricata"
			},
			"label": "Anteprima di {{name}}",
			"loading": "Caricamento dell'anteprima…",
			"open": "Anteprima",
			"pdf": {
				"fit": "Adatta",
				"interrupted": {
					"description": "Le pagine non ancora viste non si possono più scaricare. Ricarica per continuare da dove eri.",
					"reload": "Ricarica",
					"title": "L'anteprima è scaduta"
				},
				"locked": {
					"description": "L'anteprima non apre i file protetti. Scaricalo per aprirlo.",
					"title": "Questo PDF è protetto da password"
				},
				"page": "Pagina {{page}} di {{pages}}",
				"pages": "Pagine",
				"search": {
					"label": "Cerca nel documento",
					"matches": "{{current}} di {{total}}",
					"next": "Risultato successivo",
					"none": "Nessun risultato",
					"placeholder": "Cerca",
					"previous": "Risultato precedente"
				},
				"thumbnail": "Pagina {{page}}",
				"unreadable": "Il file può essere danneggiato. Scaricalo e aprilo con un lettore PDF.",
				"zoom": "Zoom",
				"zoom_in": "Ingrandisci",
				"zoom_out": "Riduci"
			},
			"refused": {
				"title": "Questo file non si può vedere in anteprima"
			},
			"too_large": {
				"description": "Sopra {{limit}} l'anteprima non viene generata, per non esaurire la memoria della scheda. Scarica il file per aprirlo.",
				"title": "Troppo grande per l'anteprima"
			},
			"unreadable": {
				"description": "Il file può essere danneggiato, o scritto in un modo che questa anteprima non capisce. Scaricalo e aprilo con Word o PowerPoint.",
				"title": "Non è stato possibile aprire questo file"
			},
			"unsupported": {
				"description": "Scaricalo per aprirlo.",
				"title": "Nessuna anteprima per questo formato"
			}
		},
		"section": {
			"files": "File",
			"folders": "Cartelle"
		},
		"select": {
			"blocked_folder": "Non puoi spostare niente da questa cartella",
			"blocked_one": "{{count}} elemento non si può spostare",
			"blocked_other": "{{count}} elementi non si possono spostare",
			"blocked_root": "Qui non c’è una cartella da cui spostare",
			"clear": "Annulla la selezione",
			"count_one": "{{count}} elemento selezionato",
			"count_other": "{{count}} elementi selezionati",
			"delete": "Elimina",
			"delete_blocked_one": "{{count}} elemento non si può eliminare",
			"delete_blocked_other": "{{count}} elementi non si possono eliminare",
			"details_multiple": "Impossibile mostrare i dettagli di più elementi",
			"item": "Seleziona {{name}}",
			"preview_multiple": "Impossibile visualizzare l’anteprima di più elementi",
			"rename_multiple": "Impossibile rinominare più elementi",
			"rename_role": "Non puoi rinominare questo elemento",
			"share_multiple": "Impossibile condividere più elementi",
			"share_role": "Non puoi condividere questo elemento"
		},
		"sort": {
			"button": "Ordina",
			"column": {
				"last_viewed": "Ultima visualizzazione",
				"name": "Nome",
				"size": "Dimensione",
				"updated": "Ultima modifica"
			},
			"direction": {
				"label": "Direzione",
				"last_viewed_asc": "Meno recenti prima",
				"last_viewed_desc": "Più recenti prima",
				"name_asc": "A → Z",
				"name_desc": "Z → A",
				"size_asc": "Più piccolo",
				"size_desc": "Più grande",
				"updated_asc": "Meno recente",
				"updated_desc": "Più recente"
			},
			"folders_first": "Cartelle sempre in cima",
			"label": "Ordina per",
			"trigger": "Ordina per: {{column}}, {{direction}}"
		},
		"tree_collapse": "Comprimi {{name}}",
		"tree_expand": "Espandi {{name}}",
		"tree_load_failed": "Impossibile caricare le cartelle",
		"tree_show_more": "Mostra altre",
		"unreachable": {
			"failed": {
				"description": "La connessione si è interrotta prima di arrivare al file. Riprova tra poco.",
				"title": "Non siamo riusciti ad aprire il file"
			},
			"file": {
				"description": "Potrebbe essere stato eliminato o spostato, oppure non è condiviso con te. Chiedi a chi ti ha mandato il link di darti accesso.",
				"title": "Non puoi aprire questo file"
			},
			"folder": {
				"description": "Potrebbe essere stata eliminata o spostata, oppure non è condivisa con te. Chiedi a chi ti ha mandato il link di darti accesso.",
				"title": "Non puoi aprire questa cartella"
			},
			"go_to_files": "Vai ai miei file",
			"trashed": {
				"description": "Puoi ripristinarlo dal cestino.",
				"title": "Spostato nel cestino"
			}
		},
		"upload": {
			"cancel": "Annulla il caricamento",
			"choose": "Carica file",
			"choose_folder": "Carica cartella",
			"close_confirm": {
				"both": "Sono ancora in corso {{uploads}} e {{downloads}}. Se chiudi ora i caricamenti si fermano e quello che è già stato inviato viene eliminato; i download vengono annullati e perdi quanto è già stato scaricato.",
				"cancel": "Mantieni aperto",
				"confirm": "Ferma tutto",
				"description_one": "C’è ancora 1 trasferimento in corso. Se chiudi ora si ferma e quello che è già stato inviato viene eliminato.",
				"description_other": "Ci sono ancora {{count}} trasferimenti in corso. Se chiudi ora si fermano e quello che è già stato inviato viene eliminato.",
				"downloads_one": "C’è ancora 1 download in corso. Se chiudi ora viene annullato e perdi quanto è già stato scaricato.",
				"downloads_other": "Ci sono ancora {{count}} download in corso. Se chiudi ora vengono annullati e perdi quanto è già stato scaricato.",
				"title": "Fermare i trasferimenti in corso?"
			},
			"done_detail": "Completato · {{size}}",
			"drop_here": "Rilascia i file per caricarli <b>qui</b>",
			"drop_home": "Rilascia i file per caricarli nei <b>tuoi file</b>",
			"drop_into": "Rilascia i file per caricarli nella cartella <b>{{name}}</b>",
			"folder": {
				"cancelled_one": "Annullata · resta nella cartella {{done}} file già caricato",
				"cancelled_other": "Annullata · restano nella cartella {{done}} file già caricati",
				"done": "Completata · {{total}} file · {{size}}",
				"done_copies_one": "Completata · {{total}} file · {{count}} caricato come copia",
				"done_copies_other": "Completata · {{total}} file · {{count}} caricati come copia",
				"done_errors_one": "{{done}} di {{total}} file caricati · {{count}} non caricato",
				"done_errors_other": "{{done}} di {{total}} file caricati · {{count}} non caricati",
				"exists": {
					"confirm": "Conferma",
					"description": "La cartella «{{name}}» esiste già in questa destinazione. Cosa vuoi fare?",
					"merge": "Carica e unisci",
					"merge_hint": "I file verranno aggiunti alla cartella esistente. Per ogni file con lo stesso nome ti chiederemo cosa fare.",
					"rename": "Carica e rinomina",
					"rename_hint": "La cartella che stai caricando verrà rinominata.",
					"skip": "Non caricare",
					"skip_hint": "Nessun file verrà modificato. Il caricamento della cartella viene annullato.",
					"title": "Elementi duplicati"
				},
				"interrupted": "Interrotta · {{done}} di {{total}} file caricati",
				"list": {
					"close": "Chiudi",
					"copies_one": "Salvato con un altro nome · {{count}}",
					"copies_other": "Salvati con un altro nome · {{count}}",
					"copy_of": "Esisteva già «{{name}}»",
					"failed_one": "Non caricato · {{count}}",
					"failed_other": "Non caricati · {{count}}",
					"summary": "{{done}} di {{total}} file caricati.",
					"title": "«{{name}}»"
				},
				"nothing": "La cartella è vuota.",
				"offline": "In attesa di connessione · {{done}} di {{total}} file",
				"preparing": "Preparazione · {{count}} file",
				"progress": "{{percent}}% · {{done}} di {{total}} file · {{sent}} di {{size}}",
				"reselect": "Scegli di nuovo la cartella",
				"reselect_mismatch": "Hai scelto un’altra cartella. Scegli «{{name}}».",
				"resume": "Riprendi",
				"see_which": "Vedi quali",
				"too_large": {
					"description": "«{{name}}» ha più di {{max}} file, il massimo che il browser carica in una volta. Usa l’app desktop, oppure carica le sottocartelle una alla volta.",
					"title": "Questa cartella è troppo grande per il browser"
				}
			},
			"folder_badge": {
				"batch_one": "{{count}} file",
				"batch_other": "{{count}} file",
				"count_one": "{{count}} file in arrivo",
				"count_other": "{{count}} file in arrivo",
				"title": "Sta caricando file in questa cartella"
			},
			"give_up": {
				"action": "Elimina il caricamento",
				"cancel": "Annulla",
				"confirm": "Elimina",
				"description": "Quello che è già stato caricato viene eliminato e il nome torna libero. Per caricare di nuovo il file si ricomincia da capo.",
				"failed": "Non è stato possibile eliminare il caricamento. È ancora in sospeso e il nome resta occupato.",
				"title": "Eliminare il caricamento di «{{name}}»?"
			},
			"overwrite": {
				"apply_to_all_one": "Applica questa opzione al prossimo duplicato",
				"apply_to_all_other": "Applica questa opzione ai prossimi {{count}} duplicati",
				"confirm": "Conferma",
				"description": "Il file «{{name}}» esiste già in questa destinazione. Cosa vuoi fare?",
				"pending": "In attesa della tua scelta.",
				"rename": "Carica e rinomina",
				"rename_hint": "Il file che stai caricando verrà rinominato in «{{newName}}».",
				"skip": "Non caricare",
				"skip_hint": "Nessun file verrà modificato. Il nuovo caricamento viene annullato e conserverai la versione già presente.",
				"title": "Elementi duplicati",
				"update": "Carica e aggiorna",
				"update_hint": "Il file verrà aggiornato mantenendo la cronologia delle versioni."
			},
			"panel": {
				"add": "Aggiungi",
				"close": "Chiudi i trasferimenti",
				"collapse": "Riduci",
				"completed": "Completato",
				"destination": "Caricamento in <folder>{{name}}</folder>",
				"destination_unavailable": "Cartella non più disponibile",
				"dismiss": "Rimuovi dall’elenco",
				"downloaded_one": "{{count}} download completato",
				"downloaded_other": "{{count}} download completati",
				"downloading_one": "{{count}} download in corso…",
				"downloading_other": "{{count}} download in corso…",
				"downloads_count_one": "{{count}} download",
				"downloads_count_other": "{{count}} download",
				"expand": "Espandi",
				"failed_one": "{{count}} non riuscito",
				"failed_other": "{{count}} non riusciti",
				"mixed_progress": "{{done}} di {{total}} caricati · {{received}} di {{size}} scaricati",
				"paused": "In pausa",
				"paused_detail": "Riprendono quando torni online",
				"pending_detail": "Riprendili dall’elenco prima che scadano",
				"pending_one": "{{count}} in sospeso",
				"pending_other": "{{count}} in sospeso",
				"progress": "{{done}} di {{total}} caricati",
				"title": "Trasferimenti",
				"transfers_in_progress": "{{uploads}} · {{downloads}} in corso",
				"uploaded_of": "{{uploaded}} di {{total}} file caricati",
				"uploaded_one": "{{count}} file caricato",
				"uploaded_other": "{{count}} file caricati",
				"uploading_one": "{{count}} file in corso…",
				"uploading_other": "{{count}} file in corso…",
				"uploads_count_one": "{{count}} caricamento",
				"uploads_count_other": "{{count}} caricamenti"
			},
			"paused_detail": "In attesa di connessione",
			"queued_detail": "In coda · {{size}}",
			"refusal": {
				"illegal_character": "Il nome contiene caratteri non validi. Rimuovi: / \\ : * ? \" < > |",
				"insufficient_role": "Non hai i permessi per caricare in questa cartella.",
				"not_found": "La cartella di destinazione non esiste o è stata spostata. Seleziona una nuova posizione.",
				"parent_trashed": "La cartella di destinazione è nel cestino. Ripristinala per procedere con il caricamento.",
				"path_too_long": "Il percorso è troppo lungo. Usa un nome più corto o una cartella meno profonda.",
				"quota_organization": "L'organizzazione non ha abbastanza spazio per questo file. Chiedi a un amministratore.",
				"quota_person": "Non hai abbastanza spazio per questo file. Liberane eliminando dei file e svuotando il cestino.",
				"unknown": "Caricamento fallito",
				"unknown_retry": "Caricamento fallito, riprova",
				"upload_target_deleted": "Qualcuno ha eliminato il file mentre lo caricavi.",
				"version_conflict": "Qualcuno ha sostituito questo file prima che il caricamento finisse. Non è andato perso niente, ma questo caricamento non è stato pubblicato.",
				"version_replaced": "Qualcuno ha aggiornato il file prima che finissi. Il tuo caricamento non è stato pubblicato."
			},
			"replacing_name": "<prefix>Nuova versione di</prefix> <file>{{name}}</file>",
			"resumable_days_one": "In sospeso · scade fra {{count}} giorno",
			"resumable_days_other": "In sospeso · scade fra {{count}} giorni",
			"resumable_hours_one": "In sospeso · scade fra {{count}} ora",
			"resumable_hours_other": "In sospeso · scade fra {{count}} ore",
			"resume": {
				"action": "Riprendi",
				"file_changed": "Impossibile leggere il file (potrebbe essere stato modificato). Selezionalo di nuovo per continuare.",
				"refusal": {
					"upload_file_mismatch": "Hai scelto un altro file. Scegli quello con cui avevi iniziato."
				}
			},
			"retry": "Riprova",
			"size_progress": "{{percent}}% · {{sent}} di {{total}}",
			"state": {
				"cancelled": "Annullato",
				"conflict": "Serve una tua scelta",
				"done": "Completato",
				"failed": "Non riuscito",
				"paused": "In pausa",
				"queued": "In coda",
				"resumable": "In sospeso",
				"sending": "In corso"
			}
		},
		"view": {
			"grid": "Layout a griglia",
			"label": "Vista",
			"list": "Layout a elenco"
		}
	},
	"groups": {
		"column_email": "Email",
		"column_member": "Membro",
		"is_member": "Ne fai parte",
		"member_count_one": "{{count}} membro",
		"member_count_other": "{{count}} membri",
		"no_members": "Nessun membro",
		"no_members_match": "Nessun membro trovato.",
		"visibility": {
			"private": "Privato",
			"private_description": "Visibile solo ai membri e agli amministratori.",
			"public": "Pubblico",
			"public_description": "Tutta l'organizzazione può trovare il gruppo, vederne i membri e condividerci file."
		},
		"you": "(tu)"
	},
	"invite": {
		"activating": "Attivazione…",
		"description": "Imposta una password e completa l'attivazione del tuo account.",
		"email": "Email",
		"failed": {
			"link_closed": {
				"description": "È scaduto o è stato usato mentre questa pagina era aperta. Chiedi a chi ti ha invitato di inviartene uno nuovo.",
				"title": "Questo invito non è più utilizzabile"
			},
			"organization_unavailable": {
				"description": "Riprova tra poco, oppure contatta chi ti ha invitato.",
				"title": "La tua organizzazione non è raggiungibile in questo momento"
			},
			"password_rejected": {
				"description": "Non rispetta le regole della tua organizzazione. Scegline un'altra: non è cambiato nulla.",
				"title": "Password rifiutata"
			},
			"provider_unavailable": {
				"description": "Il tuo invito è intatto. Invia di nuovo il modulo tra un momento.",
				"title": "Non siamo riusciti a impostare la password"
			},
			"rate_limited": {
				"description": "Aspetta qualche minuto prima di riprovare.",
				"title": "Troppi tentativi"
			},
			"unavailable": {
				"description": "Qualcosa è andato storto lungo la strada. Invia di nuovo il modulo.",
				"title": "Non siamo riusciti a completare l'attivazione"
			}
		},
		"first_name": "Nome",
		"handing_over": {
			"description": "Inserisci la password che hai appena scelto.",
			"signed_in": "Ti stiamo portando nel tuo spazio…",
			"title": "Ti stiamo portando all'accesso…"
		},
		"last_name": "Cognome",
		"loading": "Verifica dell'invito in corso…",
		"organization": "Organizzazione",
		"password": "Password",
		"password_policy": {
			"rules": {
				"digits": "contenga almeno {{value}} cifra",
				"length": "sia lunga almeno {{value}} caratteri",
				"lowerCase": "contenga almeno {{value}} lettera minuscola",
				"passwordHistory": "non sia una delle tue ultime {{value}} password",
				"specialChars": "contenga almeno {{value}} carattere speciale",
				"upperCase": "contenga almeno {{value}} lettera maiuscola"
			},
			"title": "La tua organizzazione richiede una password che:"
		},
		"refused": {
			"already_used": {
				"description": "Il tuo account è già attivo. Accedi con l'email e la password che hai scelto.",
				"go_to_login": "Vai all'accesso",
				"title": "Invito già usato"
			},
			"expired": {
				"description": "Gli inviti valgono per un tempo limitato. Chiedi a chi ti ha invitato di inviartene uno nuovo.",
				"title": "Questo invito è scaduto"
			},
			"invalid": {
				"description": "Controlla di averlo aperto per intero dall'email. Se il problema resta, chiedi a chi ti ha invitato di inviartene uno nuovo.",
				"title": "Questo link di invito non funziona"
			},
			"organization_not_ready": {
				"description": "Il tuo invito è valido. Riprova tra qualche minuto.",
				"title": "La tua organizzazione è ancora in preparazione"
			},
			"organization_suspended": {
				"description": "Finché resta sospesa non è possibile accedere. Contatta chi ti ha invitato.",
				"title": "La tua organizzazione è sospesa"
			},
			"rate_limited": {
				"description": "Aspetta qualche minuto, poi riapri il link dall'email.",
				"title": "Troppi tentativi"
			},
			"unavailable": {
				"description": "Il tuo invito non è cambiato. Ricarica la pagina per riprovare.",
				"title": "Non siamo riusciti a verificare l'invito"
			}
		},
		"submit": "Imposta la password e continua",
		"title": "Sei stato invitato in {{organization}}"
	},
	"login": {
		"continue": "Continua",
		"description": "Inserisci la tua organizzazione per accedere.",
		"oidc_callback_failed": "Accesso non completato. Riprova.",
		"redirecting": "Reindirizzamento all'accesso…",
		"request_id": "Codice richiesta: {{requestId}}",
		"slug_label": "Organizzazione",
		"slug_placeholder": "acme",
		"title": "Accedi",
		"unknown_organization": "Questa organizzazione non esiste o non accetta accessi. Controlla il nome."
	},
	"native_return": {
		"body": "Torna all'app per continuare.",
		"title": "Torna all'app"
	},
	"node_role": {
		"editor": "Editor",
		"owner": "Proprietario",
		"viewer": "Visualizzatore"
	},
	"search": {
		"popover": {
			"empty": {
				"description": {
					"all": "Nessun file o cartella corrisponde alla tua ricerca.",
					"folder": "Nessun elemento trovato in questa cartella.",
					"shared": "Nessun file condiviso corrisponde a questo nome.",
					"trash": "Nessun elemento nel cestino corrisponde alla ricerca."
				},
				"title": "Nessun risultato"
			},
			"error": "La ricerca non è riuscita. Riprova.",
			"input_label": "Cerca file e cartelle",
			"placeholder": "Cerca",
			"prompt": {
				"description": "Digita il nome di un file o di una cartella per iniziare.",
				"title": "Cerca tra i tuoi file"
			},
			"results_count_one": "{{count}} risultato",
			"results_count_other": "{{count}} risultati",
			"scope": {
				"all": "Tutti i file",
				"chip": "in: «{{name}}»",
				"label": "Ambito di ricerca",
				"remove_folder": "Cerca in tutti i file invece che solo in «{{name}}»",
				"shared": "Condivisi con me",
				"trash": "Cestino"
			},
			"see_all": "Tutti i risultati",
			"widen": "Cerca in tutti i file"
		},
		"results_page": {
			"empty": {
				"description": "Nessun risultato in {{scope}} per «{{q}}». Se questo indirizzo arriva da un collega, potresti vedere meno di quello che ha trovato lui: la ricerca mostra solo ciò a cui hai accesso.",
				"title": "Nessun risultato"
			},
			"error": {
				"description": "Non è stato possibile caricare i risultati della ricerca.",
				"title": "Qualcosa è andato storto"
			},
			"offline": {
				"description": "Sembri offline, quindi i risultati non possono essere caricati. Verranno caricati di nuovo appena torna la connessione.",
				"title": "Nessuna connessione"
			},
			"prompt": "Scrivi qualcosa per cercare.",
			"scope": {
				"all": "tutti i tuoi file",
				"folder": "questa cartella",
				"shared": "ciò che è condiviso con te"
			},
			"scope_label": "Ambito",
			"title": "Risultati di ricerca"
		}
	},
	"share": {
		"access_empty": "Nessun altro ha accesso a questo elemento.",
		"add": {
			"message_label": "Messaggio",
			"message_placeholder": "Messaggio (facoltativo)",
			"role_label": "Ruolo delle persone da aggiungere",
			"send": "Invia",
			"share": "Condividi"
		},
		"cancel": "Annulla",
		"copy_link": {
			"copied": "Link copiato",
			"failed": "Impossibile copiare il link.",
			"menu": "Copia link"
		},
		"done": "Fine",
		"drop_added": "Togli {{name}} dalla lista",
		"error": {
			"cannot_grant_to_self": "Il tuo accesso a questo elemento non lo puoi cambiare da qui. Chiedi a qualcun altro che può modificarlo.",
			"insufficient_role": "Solo chi può modificare questo elemento può gestire chi vi ha accesso.",
			"last_owner": "È l'unico proprietario. Assegna prima quel ruolo a qualcun altro.",
			"list_failed": "Non è stato possibile leggere l'elenco degli accessi. Riprova.",
			"not_found": "Questo elemento non esiste più, o non è più raggiungibile.",
			"owner_not_assignable": "Il ruolo di proprietario non si assegna: appartiene a chi ha creato l'elemento.",
			"save_failed": "Non è stato possibile salvare gli accessi. Le modifiche sono ancora qui: riprova.",
			"sharing_version_conflict": "Qualcun altro ha modificato gli accessi mentre stavi lavorando. L'elenco è stato ricaricato e le modifiche non salvate sono andate perse: rifalle e salva di nuovo."
		},
		"general": {
			"disabled_by_admin": "Disattivato dall’amministratore.",
			"editor_capped": "L’amministratore consente solo la visualizzazione.",
			"error": {
				"disabled": "L’amministratore non consente di aprire elementi a tutta l’organizzazione con questo ruolo.",
				"failed": "Non è stato possibile cambiare l’accesso. Riprova.",
				"inherited": "Una cartella che lo contiene lo apre già a tutta l’organizzazione: da qui non puoi chiuderlo né ridurlo.",
				"personal_root": "La cartella I miei file non si può aprire all’organizzazione."
			},
			"heading": "Accesso generale",
			"inherited": "Aperto tramite la cartella {{name}}: qui puoi solo dare di più.",
			"level_label": "Chi può aprirlo con il link",
			"load_failed": "Non è stato possibile leggere l’accesso generale.",
			"organization": "Organizzazione",
			"organization_description": {
				"editor": "Chiunque in questa organizzazione abbia il link può modificare l’elemento.",
				"viewer": "Chiunque in questa organizzazione abbia il link può visualizzare l’elemento."
			},
			"organization_fallback": "tutta l’organizzazione",
			"restricted": "Con limitazioni",
			"restricted_description": "Solo le persone con accesso possono usare il link per aprire l’elemento.",
			"role": {
				"editor": "Può modificare",
				"viewer": "Può vedere"
			},
			"role_label": "Cosa può fare chi apre il link"
		},
		"group_gone": "Gruppo non più disponibile",
		"group_heading": "Gruppi",
		"group_inherited": "Gruppo · Ereditato da «{{name}}»",
		"group_label": "Gruppo",
		"group_line_one": "Gruppo · {{count}} membro",
		"group_line_other": "Gruppo · {{count}} membri",
		"group_line_private_one": "Gruppo privato · {{count}} membro",
		"group_line_private_other": "Gruppo privato · {{count}} membri",
		"group_view_members": "Vedi membri",
		"inherited_from": "Ereditato da «{{name}}»",
		"link": {
			"back": "Torna alla condivisione",
			"create": "Crea link",
			"create_title": "Nuovo link pubblico",
			"created": "Link creato.",
			"created_copied": "Link creato e copiato negli appunti.",
			"creating": "Creazione…",
			"expired_description": "Puoi crearne uno nuovo, con un indirizzo diverso.",
			"expired_title": "Il tuo link è scaduto",
			"expires_badge": "Scade il {{date}}",
			"expiry": {
				"label": "Scadenza",
				"max_date": "La tua organizzazione consente una scadenza fino al {{date}}.",
				"toggle_label": "Imposta una scadenza",
				"tooltip": "Dopo questa data il link scade e non si può più usare."
			},
			"heading": "Link pubblico",
			"load_failed": "Non è stato possibile caricare il link.",
			"manage": "Gestisci",
			"none_description": "Chiunque abbia il link potrà vedere e scaricare l’elemento, anche fuori da {{org}} e senza accedere.",
			"others_gone": "un account non più disponibile",
			"others_one": "{{names}} ha un link attivo su questo elemento.",
			"others_other": "{{names}} hanno un link attivo su questo elemento.",
			"own_blocked": "Sospeso finché l'amministratore non riattiva i link.",
			"own_description": "Chiunque abbia questo link può visualizzare e scaricare",
			"password": {
				"change": "Cambia",
				"label": "Password",
				"set": "Password impostata",
				"toggle_label": "Proteggi con una password",
				"tooltip": "Chi apre il link deve inserire questa password per accedere all’elemento."
			},
			"password_badge": "Password",
			"password_reminder": "Il link non contiene la password: mandala a parte.",
			"refusal": {
				"already_exists": "Hai già un link attivo su questo elemento.",
				"expiry_out_of_range": "La tua organizzazione non consente questa data.",
				"not_allowed": "La tua organizzazione ha disattivato i link. Chiedi a un amministratore.",
				"password_required": "La tua organizzazione richiede una password sui link."
			},
			"required": {
				"badge": "Obbligatorio",
				"both": "Ogni link pubblico deve avere una password e una data di scadenza. Impostale qui sotto per creare il link.",
				"expiry": "Ogni link pubblico deve avere una data di scadenza. Sceglila qui sotto per creare il link.",
				"password": "Ogni link pubblico deve avere una password. Impostala qui sotto per creare il link.",
				"title": "Richiesto dalla tua organizzazione"
			},
			"revoke": "Revoca link",
			"revoke_confirm_title": "Revocare il link?",
			"revoked": "Link revocato.",
			"revoking": "Revoca in corso…",
			"row": {
				"active_title": "Hai un link pubblico attivo",
				"cta": "Crea un link pubblico",
				"title": "Vuoi condividerlo fuori da {{org}}?",
				"view": "Visualizza"
			},
			"settings": "Impostazioni del link",
			"unavailable_description": "La tua organizzazione non li consente.",
			"unavailable_title": "Link pubblici non disponibili",
			"url_label": "Indirizzo del link",
			"view_title": "Link pubblico di «{{name}}»"
		},
		"menu": "Condividi",
		"notify": "Avvisa via email",
		"notify_failed": "Permessi salvati. Non è stato possibile inviare l'email di avviso.",
		"open": "Condividi",
		"pending": "Da salvare",
		"people_heading": "Persone con accesso",
		"person_already": "Ha già accesso",
		"person_empty": "Nessuno trovato. Chi ha ricevuto un invito compare qui solo dopo averlo accettato.",
		"person_gone": "Account non più disponibile",
		"person_label": "Persona o gruppo",
		"person_placeholder": "Aggiungi persone o gruppi",
		"picker_people_heading": "Persone",
		"remove_access": "Rimuovi accesso",
		"removed_downloads": "Chi aveva già avviato un download può completarlo.",
		"request": {
			"back": "Torna al link",
			"create": "Crea link",
			"description": "Chi ha il link può caricare file in questa cartella senza accedere, ma non ne vede il contenuto.",
			"links_off": "I link sono disattivati dall'amministratore",
			"load_failed": "Non è stato possibile caricare il link di caricamento.",
			"menu": "Link di caricamento",
			"message_count": "{{length}} / {{max}}",
			"message_heading": "Messaggio",
			"message_label": "Messaggio per chi invia (Facoltativo)",
			"message_placeholder": "Ad esempio: carica qui le fatture del trimestre.",
			"others_one": "{{names}} ha un link di caricamento attivo su questa cartella.",
			"others_other": "{{names}} hanno un link di caricamento attivo su questa cartella.",
			"required": {
				"both": "Ogni link deve avere una password e una data di scadenza. Impostale qui sotto per creare il link.",
				"expiry": "Ogni link deve avere una data di scadenza. Sceglila qui sotto per creare il link.",
				"password": "Ogni link deve avere una password. Impostala qui sotto per creare il link."
			},
			"revoke_confirm": "Chi ha il link non potrà più inviarti file. I file già arrivati restano nella cartella.",
			"settings": "Impostazioni del link",
			"title": "Link di caricamento per «{{name}}»",
			"unavailable_description": "La tua organizzazione non le consente.",
			"unavailable_title": "Link di caricamento non disponibili"
		},
		"role_actions": {
			"editor": "Crea, modifica, carica, rinomina e sposta.",
			"viewer": "Vede e scarica. Non modifica nulla."
		},
		"role_of": "Ruolo di {{name}}",
		"save": "Salva",
		"saved": "Accessi aggiornati.",
		"saving": "Salvataggio…",
		"title": "Accesso a «{{name}}»",
		"unsaved": "Modifiche in sospeso"
	},
	"shared": {
		"empty": {
			"description": "Quando qualcuno condividerà una cartella con te, la troverai qui.",
			"title": "Non c’è ancora niente qui"
		},
		"error": {
			"description": "Riprova: non è cambiato niente.",
			"title": "Non siamo riusciti a caricare le condivisioni"
		},
		"offline": {
			"description": "Sembri offline, quindi non possiamo controllare cosa è stato condiviso con te. Riproveremo appena torna la connessione."
		},
		"sharer_unknown": "sconosciuto",
		"title": "Condivisi con me"
	},
	"shortcuts": {
		"action": {
			"create_folder": "Nuova cartella",
			"create_upload": "Carica file",
			"create_upload_folder": "Carica cartella",
			"folder_up": "Vai alla cartella superiore",
			"help": "Mostra le scorciatoie da tastiera",
			"listing_extend": "Estendi la selezione",
			"listing_move": "Spostati tra gli elementi",
			"listing_open": "Apri",
			"listing_paste": "Incolla gli elementi copiati",
			"listing_toggle": "Seleziona o deseleziona l'elemento",
			"search_focus": "Cerca",
			"selection_all": "Seleziona tutto",
			"selection_clear": "Deseleziona tutto",
			"selection_copy": "Copia gli elementi selezionati",
			"selection_delete": "Sposta nel cestino",
			"selection_download": "Scarica",
			"selection_rename": "Rinomina",
			"sidebar_toggle": "Mostra o nascondi la barra laterale"
		},
		"dialog": {
			"title": "Scorciatoie da tastiera"
		},
		"group": {
			"create": "Crea",
			"general": "Generali",
			"listing": "Elenco",
			"selection": "Selezione"
		},
		"or": "o",
		"then": "poi"
	},
	"trash": {
		"columns": {
			"deleted_at": "Eliminato il",
			"deleted_by": "Eliminato da",
			"name": "Nome",
			"origin": "Posizione di origine",
			"size": "Dimensione",
			"type": "Tipo"
		},
		"delete": {
			"action": "Elimina definitivamente",
			"confirm": "Elimina definitivamente",
			"confirm_description_one": "«{{name}}» verrà eliminato definitivamente e non potrà essere ripristinato.",
			"confirm_description_other": "{{count}} elementi verranno eliminati definitivamente e non potranno essere ripristinati.",
			"confirm_title": "Eliminare definitivamente?",
			"deleting": "Eliminazione…",
			"done_one": "Elemento eliminato definitivamente.",
			"done_other": "{{count}} elementi eliminati definitivamente.",
			"refusal": {
				"node_purged": "È già in eliminazione definitiva.",
				"purge_not_allowed": "Solo {{name}} può eliminarlo definitivamente.",
				"purge_not_allowed_others_one": "Solo {{name}} può eliminarlo definitivamente: contiene 1 elemento creato da qualcun altro.",
				"purge_not_allowed_others_other": "Solo {{name}} può eliminarlo definitivamente: contiene {{count}} elementi creati da qualcun altro.",
				"purge_not_allowed_unknown": "Non puoi eliminarlo definitivamente.",
				"state_conflict": "Non è più nel cestino.",
				"unknown": "Non è stato possibile eliminarlo definitivamente."
			},
			"refusal_line": "«{{name}}»: {{reason}}",
			"refused_one": "Un elemento non è stato eliminato.",
			"refused_other": "{{count}} elementi non sono stati eliminati."
		},
		"deleted_by": {
			"unknown": "Account eliminato"
		},
		"empty": {
			"button_label": "Svuota cestino",
			"confirm": "Svuota cestino",
			"confirm_description_one": "1 elemento ({{bytes}}) verrà eliminato definitivamente e non potrà essere ripristinato.",
			"confirm_description_other": "{{count}} elementi ({{bytes}}) verranno eliminati definitivamente e non potranno essere ripristinati.",
			"confirm_title": "Svuotare il cestino?",
			"count_changed": "Il numero di elementi è cambiato nel frattempo. Controlla la cifra aggiornata e conferma di nuovo.",
			"done_one": "1 elemento eliminato definitivamente.",
			"done_other": "{{count}} elementi eliminati definitivamente.",
			"emptying": "Svuotamento…",
			"error": "Non è stato possibile svuotare il cestino. Riprova.",
			"kept_one": "1 elemento resta nel cestino perché appartiene a qualcun altro.",
			"kept_other": "{{count}} elementi restano nel cestino perché appartengono ad altri."
		},
		"empty_state": {
			"description": "Gli elementi spostati nel cestino verranno eliminati definitivamente dopo 30 giorni",
			"title": "Il cestino è vuoto"
		},
		"error": {
			"description": "Non è stato possibile caricare il cestino. Riprova.",
			"title": "Impossibile caricare il cestino"
		},
		"nav_label": "Cestino",
		"offline": {
			"description": "Sembri offline, quindi il cestino non è raggiungibile. Verrà caricato di nuovo appena torna la connessione."
		},
		"origin": {
			"unavailable": "Non disponibile"
		},
		"page_title": "Cestino",
		"restore": {
			"action": "Ripristina",
			"done_one": "Elemento ripristinato.",
			"done_other": "{{count}} elementi ripristinati.",
			"name_conflict": {
				"description": "Il nome è già in uso nella cartella di destinazione. Puoi ripristinarlo come «{{suggestedName}}».",
				"rename_action": "Ripristina rinominando",
				"title": "Nome già in uso per «{{name}}»"
			},
			"origin_error": "Non è stato possibile ripristinare la cartella di origine. Riprova.",
			"origin_trashed": {
				"choose_destination_action": "Scegli dove ripristinare",
				"description": "La cartella «{{parentName}}», da cui proviene, è anch’essa nel cestino.",
				"restore_origin_action": "Ripristina la cartella di origine",
				"title": "La cartella di origine di «{{name}}» è nel cestino",
				"unnamed_folder": "questa cartella"
			},
			"picker": {
				"back": "Indietro",
				"confirm": "Ripristina qui",
				"title": "Scegli dove ripristinare"
			},
			"purged_one": "1 elemento era già stato eliminato definitivamente da qualcun altro.",
			"purged_other": "{{count}} elementi erano già stati eliminati definitivamente da qualcun altro.",
			"refusal": {
				"insufficient_role": "Non puoi più ripristinare questo elemento.",
				"name_taken": "Nella cartella d’origine c’è già un elemento con questo nome.",
				"parent_trashed": "La cartella d’origine è nel cestino.",
				"state_conflict": "Non è più nel cestino.",
				"unknown": "Non è stato possibile ripristinarlo."
			},
			"refusal_line": "«{{name}}»: {{reason}}",
			"refused_one": "Un elemento non è stato ripristinato.",
			"refused_other": "{{count}} elementi non sono stati ripristinati.",
			"restoring": "Ripristino…"
		},
		"retention_banner": "Gli elementi nel cestino verranno eliminati definitivamente dopo 30 giorni"
	}
}
